var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWater = function SvgWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263F54",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M16.453 11.25h5.08m-1.129 2.823h2.823a3.39 3.39 0 0 1 3.387 3.387v1.693h-3.387v-1.09c0-.643-.486-1.168-1.13-1.168h-9.596m0-2.822h5.08m2.823.564v-.282a1.412 1.412 0 0 0-2.822 0v.282m8.479 9.721c.395.43 1.117 1.23 1.117 2.134 0 1.293-1.01 2.258-2.258 2.258s-2.258-.965-2.258-2.258c0-.87.672-1.637 1.135-2.14l1.123-1.247z"
  })));
};
export default SvgWater;